var map = {
	"./fonts/HurmeGeometricSans3Black.otf": [
		137,
		9,
		4
	],
	"./fonts/Renner.ttf": [
		138,
		9,
		5
	],
	"./icon/icon_512.png": [
		70,
		9
	],
	"./template/catalog/trans_256x128.png": [
		69,
		9
	],
	"./template/products": [
		54,
		3
	],
	"./template/products.json": [
		54,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 126;
module.exports = webpackAsyncContext;